import script from "./VerificationDocs.vue?vue&type=script&setup=true&lang=ts"
export * from "./VerificationDocs.vue?vue&type=script&setup=true&lang=ts"

import "./VerificationDocs.vue?vue&type=style&index=0&id=12c46170&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12c46170"]])

export default __exports__